import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/comments.php
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var inGames = Util.in(global.gameIds)
		global.userComments = {}
		global.gameComments = {}

		if (global.userID) {
			var userRows = DB.query('SELECT game_id, comment_text FROM comment WHERE game_id IN(' + inGames + ') AND user_id = ?', [global.userID])
			for (var i = 0; i < userRows.length; i++) {
				global.userComments[userRows[i].game_id] = userRows[i].comment_text
			}
		}

		if (global.ownerType !== 1 && global.userIndex && global.userIndex.length) {
			var inUsers = Util.in(global.userIndex)
			var gameRows = DB.query('SELECT game_id as game, COUNT(comment_id) as comments FROM comment WHERE user_id IN(' + inUsers + ') AND game_id IN(' + inGames + ') GROUP BY game_id')
			for (var j = 0; j < gameRows.length; j++) {
				global.gameComments[gameRows[j].game] = {
					game: gameRows[j].game,
					comments: parseInt(gameRows[j].comments || 0, 10)
				}
			}
		}
	}
}
